module.exports = {
    pageTitle: {
        sepalater: ' | ',
        base: '粗食屋 番風'
    }
}